import { FiCheck, FiCircle } from "react-icons/fi";
import { FaCircle } from "react-icons/fa";
import { ImSpinner2 } from "react-icons/im";

const data = {
    data: [
        {
            widgetTitle: "2022",
            items: [
                {
                    projectTitle: "Q1",
                    projectStatus: "DONE",
                    projectStatusIcon: <FiCheck />,
                    projectFeatures: [
                        {
                            text: "Metaverse launch",
                            icon: <FaCircle />
                        },
                        {
                            text: "Publish Nest Bithu App (IOS & Google Play)",
                            icon: <FaCircle />
                        },
                        {
                            text: "Development of NFT market",
                            icon: <FaCircle />
                        },
                        {
                            text: "Project White Paper",
                            icon: <FaCircle />
                        },
                        {
                            text: "Start minting",
                            icon: <FaCircle />
                        },
                    ]
                },
                {
                    projectTitle: "Q2",
                    projectStatus: "DONE",
                    projectStatusIcon: <FiCheck />,
                    projectFeatures: [
                        {
                            text: "First NFT pre-orders",
                            icon: <FaCircle />
                        },
                        {
                            text: "Full-scale platform launch",
                            icon: <FaCircle />
                        },
                        {
                            text: "Development of NFT market",
                            icon: <FaCircle />
                        },
                        {
                            text: "Project White Paper",
                            icon: <FaCircle />
                        },
                        {
                            text: "Indie game portal",
                            icon: <FaCircle />
                        },
                    ]
                },
                {
                    projectTitle: "Q3",
                    projectStatus: "PENDING",
                    projectStatusIcon: <ImSpinner2 />,
                    projectFeatures: [
                        {
                            text: "Boost marketing across social mediums",
                            icon: <FaCircle />
                        },
                        {
                            text: "FiCircle",
                            icon: <FiCircle />
                        },
                        {
                            text: "Blockchain domination",
                            icon: <FiCircle />
                        },
                        {
                            text: "Hire Content teams",
                            icon: <FiCircle />
                        },
                    ]
                },
                {
                    projectTitle: "Q4",
                    projectStatus: "UPCOMING",
                    projectStatusIcon: "",
                    projectFeatures: [
                        {
                            text: "Separate: Limited time NFT bundles & Skins",
                            icon: <FiCircle />
                        },
                        {
                            text: "Collection Launch",
                            icon: <FiCircle />
                        },
                        {
                            text: "Development of NFT market",
                            icon: <FiCircle />
                        },
                        {
                            text: "Web 3.0 E-commerce",
                            icon: <FiCircle />
                        },
                        {
                            text: "Decentraland",
                            icon: <FiCircle />
                        },
                    ]
                },
            ],
        },
        {
            widgetTitle: "2023",
            items: [
                {
                    projectTitle: "Q1",
                    projectStatus: "UPCOMING",
                    projectFeatures: [
                        {
                            text: "Game design document drafted",
                            icon: <FiCircle />
                        },
                        {
                            text: "Actual gameplay video release",
                            icon: <FiCircle />
                        },
                        {
                            text: "NFT airdrop",
                            icon: <FiCircle />
                        },
                    ]
                },
                {
                    projectTitle: "Q2",
                    projectStatus: "UPCOMING",
                    projectFeatures: [
                        {
                            text: "Community-only whitelisting round",
                            icon: <FiCircle />
                        },
                        {
                            text: "Game design document",
                            icon: <FiCircle />
                        },
                        {
                            text: "Development of NFT market",
                            icon: <FiCircle />
                        },
                        {
                            text: "Project White Paper",
                            icon: <FiCircle />
                        },
                        {
                            text: "Product rebranding",
                            icon: <FiCircle />
                        },
                    ]
                },
                {
                    projectTitle: "Q3",
                    projectStatus: "UPCOMING",
                    projectFeatures: [
                        {
                            text: "Metaverse launch",
                            icon: <FiCircle />
                        },
                        {
                            text: "Concept created",
                            icon: <FiCircle />
                        },
                        {
                            text: "Development of NFT market",
                            icon: <FiCircle />
                        },
                        {
                            text: "Project White Paper",
                            icon: <FiCircle />
                        },
                    ]
                },
                {
                    projectTitle: "Q4",
                    projectStatus: "UPCOMING",
                    projectFeatures: [
                        {
                            text: "Advisors on board",
                            icon: <FiCircle />
                        },
                        {
                            text: "More than 20 partnerships formed",
                            icon: <FiCircle />
                        },
                        {
                            text: "NFT available in Opensea",
                            icon: <FiCircle />
                        },
                        {
                            text: "Global community",
                            icon: <FiCircle />
                        },
                    ]
                },
            ],
        },
    ]
}

export default data;